import { render } from "./Notification.vue?vue&type=template&id=75a09899"
const script = {}
script.render = render

export default script